/**
 * Spinner — the one canonical spinner (Design System §3.13).
 *
 * 16px ring by default: --border-2 track, --accent head, 0.9s linear spin.
 * Use for background syncs, always with a label where space allows
 * ("Syncing GAM…"). For inline "thinking" states prefer LoadingDots;
 * for known-shape content prefer shimmer skeletons.
 */

import React from 'react';

interface SpinnerProps {
  /** Ring diameter in px. */
  size?: number;
  /** Optional label rendered beside the ring (11px/600 --fg-3). */
  label?: string;
  style?: React.CSSProperties;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 16, label, style }) => {
  const ring: React.CSSProperties = {
    width: size,
    height: size,
    borderRadius: '50%',
    border: '2px solid var(--border-2)',
    borderTopColor: 'var(--accent)',
    animation: 'cgConicSpin 0.9s linear infinite',
    flexShrink: 0,
    boxSizing: 'border-box',
  };

  if (!label) return <span style={{ ...ring, display: 'inline-block', ...style }} aria-label="Loading" role="status" />;

  return (
    <span
      role="status"
      style={{ display: 'inline-flex', alignItems: 'center', gap: 8, ...style }}
    >
      <span style={ring} />
      <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--fg-3)' }}>{label}</span>
    </span>
  );
};

export default Spinner;
